<form class="row" [formGroup]="form">
    <div class="col-12 d-flex flex-column flex-md-row px-5">
        <ui-calendar-range-control
            [horizontal]="true"
            [maxDate]="currentDate"
            [dateFormat]="calendarFormat"
            [formControlName]="'date'"
            [label]="'global.labels.date' | translate" />

        <ui-button
            [disabled]="!date?.value || pending"
            [prefix]="bsIconTypes.Search"
            [class]="'ms-3 mt-4 mt-md-0'"
            [label]="'global.actions.search' | translate"
            (handlerClick)="handlerSubmit()" />
    </div>
</form>
